/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import {
  Placeholder,
  Text,
  withSitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';
import compose from 'lodash/fp/compose';
import defaultsDeep from 'lodash/defaultsDeep';
import get from 'lodash/get';
import Spacer from '../../ui/Spacer';
import createButtonCss from '../../ui/Button/Button';
import DotComponent from '../../ui/DotComponent';
import { modalIds, ModalsConsumer } from '../../../contexts/ModalsContext';
import { keyColors } from '../../../styles/colors';
import { Container, Column, Row } from '../../../styles/Grid';
import { processButtonData } from '../../../utils/analytics';
import { COMMONS as dict } from '../../../utils/dictionarykeys';
import { getPrefilledSolutionValue } from '../../../utils/getPrefilledSolutionValue';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import * as styles from './index.styles';

const defaultData = {
  BodyDescription: {
    value: '',
  },
  Headline: {
    value: '',
  },
  PhoneNumber: {
    value: '',
  },
};

class CTAModule extends SafePureComponent {
  handleClick = (componentName, openModal) => {
    const { sitecoreContext, t } = this.props;

    processButtonData(componentName, t(dict.GET_IN_TOUCH));

    openModal(modalIds.enquiry, {
      Solution: getPrefilledSolutionValue(sitecoreContext),
    });
  };

  safeRender() {
    const { props } = this;
    const { t } = props;
    const fields = defaultsDeep(props.fields, defaultData);
    const componentName = get(props, 'rendering.componentName', '');

    return (
      <Spacer
        backgroundColor={keyColors.brown10}
        paddingCss={styles.containerPadding}
      >
        <Container>
          <Row>
            <Column cols={{ sm: 6, md: 8, lg: 9, xl: 9 }} offsets={{ lg: 1 }}>
              <h2 css={styles.headline}>
                <Text field={fields.Headline} />
                <DotComponent />
              </h2>
              <p css={styles.bodyDescription}>
                <Text field={fields.BodyDescription} />
              </p>
            </Column>
          </Row>
          <Row>
            <Column
              css={styles.buttonWrapper}
              cols={{ sm: 6, md: 3, lg: 3, xl: 2 }}
              offsets={{ lg: 1 }}
            >
              <ModalsConsumer>
                {({ openModal }) => (
                  <button
                    css={createButtonCss()}
                    onClick={() => {
                      this.handleClick(componentName, openModal);
                    }}
                  >
                    {t(dict.GET_IN_TOUCH)}
                  </button>
                )}
              </ModalsConsumer>
            </Column>
            <Column>
              <div css={styles.phoneNumber}>
                <Placeholder
                  name="jss-phone"
                  params={{ componentName }}
                  rendering={props.rendering}
                />
              </div>
            </Column>
          </Row>
        </Container>
      </Spacer>
    );
  }
}

const objectValueType = {
  value: PropTypes.string,
};

CTAModule.defaultProps = { fields: defaultData, t: key => key };

CTAModule.displayName = 'CTAModule';

CTAModule.propTypes = {
  fields: PropTypes.shape({
    BodyDescription: PropTypes.shape(objectValueType),
    Headline: PropTypes.shape(objectValueType),
    PhoneNumber: PropTypes.shape(objectValueType),
  }),
};

export default compose(withSitecoreContext(), withNamespaces())(CTAModule);
